import React from "react";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";

function ProductSearch({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <div className="caf-product-search">
      <FaSearch className="caf-product-search__icon" aria-hidden="true" />
      <input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={t("Search products...")}
        className="caf-product-search__input"
        aria-label={t("Search products...")}
      />
    </div>
  );
}

export default ProductSearch;
